var _defs, _path, _circle, _circle2, _circle3, _text, _text2, _text3, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalentlenzAccessModelsChannelMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 440,
    viewBox: "0 0 1200 440",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "TalentLenz access models channel map") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tlamLine",
    x1: 115,
    y1: 70,
    x2: 1085,
    y2: 370,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#80C4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3885"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M600 202C420 202 388 118 238 118M600 202C438 202 420 330 238 330M600 202C770 202 790 223 962 223",
    fill: "none",
    stroke: "url(#tlamLine)",
    strokeWidth: 2.5,
    strokeDasharray: "7 8",
    opacity: 0.75
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 202,
    r: 108,
    fill: "#07152A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 202,
    r: 126,
    fill: "none",
    stroke: "#80C4FF",
    strokeOpacity: 0.35
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 202,
    r: 145,
    fill: "none",
    stroke: "#087CFF",
    strokeOpacity: 0.16
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 171,
    fill: "#80C4FF",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11.5,
    fontWeight: 800,
    letterSpacing: 1.7
  }, "OPPORTUNITY")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 203,
    fill: "#FFFFFF",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 20,
    fontWeight: 790
  }, "Senior Mine Planner")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 229,
    fill: "#C1CDDC",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12.5
  }, "Access configured by HR")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 54,
    width: 352,
    height: 130,
    rx: 22,
    fill: "#FFFFFF",
    stroke: "#C9DCF2",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 103,
    r: 24,
    fill: "#EAF4FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 103,
    r: 13,
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97 103h26M110 90c5 6 5 20 0 26M110 90c-5 6-5 20 0 26",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 94,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 18,
    fontWeight: 780
  }, "Public"), /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 118,
    fill: "#50647F",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12.5
  }, "Listed on the opportunity board"), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 135,
    width: 142,
    height: 7,
    rx: 3.5,
    fill: "#BDD8F7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 266,
    width: 352,
    height: 130,
    rx: 22,
    fill: "#FFFFFF",
    stroke: "#F4C5D8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 315,
    r: 24,
    fill: "#FFF1F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103 320-3 3a7 7 0 0 1-10-10l7-7a7 7 0 0 1 10 0M117 310l3-3a7 7 0 0 1 10 10l-7 7a7 7 0 0 1-10 0M100 323l20-20",
    transform: "translate(-2 -3) scale(.75)",
    fill: "none",
    stroke: "#FF3885",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 306,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 18,
    fontWeight: 780
  }, "Link-only"), /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 330,
    fill: "#50647F",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12.5
  }, "Unique link or QR code"), /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 347,
    width: 175,
    height: 7,
    rx: 3.5,
    fill: "#F7B9D1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328,
    y: 295,
    width: 54,
    height: 54,
    rx: 8,
    fill: "#07152A"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 337,
    y: 304,
    width: 13,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 304,
    width: 13,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337,
    y: 327,
    width: 13,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355,
    y: 323,
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 331,
    width: 7,
    height: 9
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 786,
    y: 158,
    width: 352,
    height: 130,
    rx: 22,
    fill: "#FFFFFF",
    stroke: "#C9DCF2",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 834,
    cy: 207,
    r: 24,
    fill: "#EAF4FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 822,
    y: 202,
    width: 24,
    height: 19,
    rx: 4,
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827 202v-4a7 7 0 0 1 14 0v4",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 874,
    y: 198,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 18,
    fontWeight: 780
  }, "Private"), /*#__PURE__*/React.createElement("text", {
    x: 874,
    y: 222,
    fill: "#50647F",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12.5
  }, "Invitation sent to selected applicants"), /*#__PURE__*/React.createElement("rect", {
    x: 874,
    y: 239,
    width: 191,
    height: 7,
    rx: 3.5,
    fill: "#BDD8F7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalentlenzAccessModelsChannelMap);
export default __webpack_public_path__ + "static/media/talentlenz-access-models-channel-map.67de8abc41dba8cec106742725de5767.svg";
export { ForwardRef as ReactComponent };